import SidebarToggle from "../ui/sidebar-toggle";;
import BusinessContext from "../../contexts/business-context";
import { useContext } from "react";
import DynamicIcon from "../ui/dynamic-icon";
import Link from "next/link";

const MainMenuItems = ({ children }) => {
  const businessCtx = useContext(BusinessContext);
  const business = businessCtx.activeBusiness;
  return (
    <div className="grid gap-[28px] content-start">
      <div className={`flex items-center justify-between ${business.is_pseudonymous ? '' : 'mx-[20.5px] lg:mx-0 lg:ml-[30px] lg:mr-[18px]'} `}>
        {/* peg logo / icons goes here */}
        <Link href={`/${business.uuid}/home`} className="lg:p-[10px]">
          <DynamicIcon name='user-round' size={24} />
        </Link>
        <SidebarToggle />
      </div>
      <div className="grid h-full h-fit overflow-y-auto overflow-x-hidden custom-scrollbar lg:px-[17.5px]">
        <div className="grid gap-4">
          {children}
        </div>
      </div>
    </div>
  );
}

export default MainMenuItems;
